module.exports = __webpack_public_path__ + "img/partner-sonnweber.36ff1b8c.jpg";